import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const PolicyPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, md: 8 } }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
          Policy
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '1rem', md: '1.15rem' }, mb: 3 }}>
          We value your privacy and strive to be transparent about how we handle your data. Please read our store policies below:
        </Typography>
        <Typography variant="h6" sx={{ mt: 4, mb: 1, fontSize: { xs: '1.15rem', md: '1.25rem' } }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" sx={{ fontSize: { xs: '0.97rem', md: '1.08rem' } }}>
          - We do not share your personal information with third parties.<br/>
          - All transactions are secured with industry-standard encryption.<br/>
          - You can request deletion of your data at any time.
        </Typography>
        <Typography variant="h6" sx={{ mt: 4, mb: 1, fontSize: { xs: '1.15rem', md: '1.25rem' } }}>
          Shipping & Returns
        </Typography>
        <Typography variant="body2" sx={{ fontSize: { xs: '0.97rem', md: '1.08rem' } }}>
          - Fast shipping on all orders.<br/>
          - Easy 7-day return policy.<br/>
          - Contact support for any order issues.
        </Typography>
      </Box>
    </Container>
  );
};

export default PolicyPage;
